const publicApiKeys = (() => {
    const serializedKeys = process.env.REACT_APP_PUBLIC_API_KEYS || "{}";

    try {
        return JSON.parse(serializedKeys);
    } catch (error) {
        throw new Error("REACT_APP_PUBLIC_API_KEYS must be valid JSON");
    }
})();

export const getPublicApiKey = (backend) => {
    const apiKey = publicApiKeys[backend];

    if (!apiKey) {
        throw new Error(`Public API key is not configured for ${backend}`);
    }

    return apiKey;
};
